/** 首页 小部件开放平台协议，是否点击了已读，标记放到localStoragey中 */
export const agreedFlag = '__home_page_agreed_to_the_agreement';
export enum AgreeEnum {
  /** 已读 */
  YES = '1',
  /** 稍后 */
  NO = '0',
}
export const setArgtStorage = (value: AgreeEnum) => {
  localStorage.setItem(agreedFlag, value);
};
export const getArgtStorage = () => {
  return localStorage.getItem(agreedFlag);
};
export const removeArgtStorage = () => {
  return localStorage.removeItem(agreedFlag);
};
